<div class="pricing-summary">
	<div class="total-price">
		@if (!clientView || show3YearsTotalForClient) {
			<div class="three-years-label">
				<label>{{ 'pricing-details.summary-total' | translate }}</label>
			</div>
			<span id="total-price">{{ totalPrice() | price | async }}</span>
		}
	</div>
</div>

<div class="pdf-download-box">
	@if (allowPdfDownload) {
		<div class="download-offer-wrapper" nbTooltip="{{tooltipForDisableDownloadButton}}" [nbTooltipPlacement]="nbStart" [nbTooltipTrigger]="noop" (mouseover)="showTooltipIfAllowed()" (mouseleave)="hideTooltip()">
			<button [ngClass]="clientView ? 'download-offer-pdf' : 'download-offer-pdf-reviewer'" nbButton outline size="medium" (click)="downloadOfferPdf()" [disabled]="disablePdfDownloadButton">
				<span>{{'estimate.download' | translate}}</span>
				<nb-icon id="download-icon" icon="download"></nb-icon>
			</button>
		</div>
	}

	<div [ngClass]="{'summary-price-info': true, 'additional-margin': !allowPdfDownload}">{{'pricing-details.summary-price-info' | translate}}</div>
	@if (allowPdfDownload) {
		<div id="download-offer-pdf-text" [class.additional-margin]="!showDownloadButtonText">
			@if (showDownloadButtonText) {
				<span>{{ 'pricing-details.summary-pdf-info' | translate }}</span>
			}
		</div>
	}
</div>
